import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'  // Importa o Vue Router
import './main.css';  // Importa o Tailwind CSS
import '@fortawesome/fontawesome-free/css/all.min.css';

// Adiciona logs para debug
//console.log('Initializing Vue app')
//console.log('Router configuration:', router.options.routes)


const app = createApp(App)  // Cria a instância da aplicação


const pinia = createPinia()
app.use(pinia)


//console.log('Adding router to Vue app')

app.use(router)  // Usa o Vue Router na instância

//console.log('Mounting Vue app')
app.mount('#app')  // Monta a aplicação na div com id 'app'



//console.log('Router configuration:', router.options.routes)


// Adiciona um handler global para erros não capturados
//app.config.errorHandler = (err, vm, info) => {
//    console.error('Vue Error:', err)
//    console.error('Component:', vm)
//    console.error('Info:', info)
//  }


